<div class="dvq-row dvq-filter-row">
  <dcc-billboard
    label="Devices"
    [value]="total | number"></dcc-billboard>

  <dcc-entity-search
    [clearTextOnSelect]="true"
    [entityTypes]="entitySearchTypes"
    (entity)="onEntitySelected($event)"></dcc-entity-search>

  <module-search
    class="dvq-typeahead"
    placeHolder="Search Module Name or Version"
    [autoClearInput]="true"
    [enableDeviceTypes]="false"
    [moduleDisplayName]="null"
    [modules]="modules"
    (module)="onModuleSelected($event)"></module-search>

  <cohort-release-search
    class="dvq-typeahead"
    placeHolder="Search Release or Cohort"
    (select)="onCohortOrReleaseSelected($event)"></cohort-release-search>

  <dcc-loading-indicator
    *ngIf="isLoading"
    class="button-group"></dcc-loading-indicator>

  <div
    *ngIf="!isLoading"
    class="button-group">
    <button
      class="lx-btn lx-btn-negative query-builder__basic__search"
      (click)="onSearch()">
      Search
    </button>
    <dcc-reset-button (reset)="onReset()"></dcc-reset-button>
  </div>
</div>

<div
  *ngIf="
    entities?.length ||
    selectedModules?.length ||
    cohorts?.length ||
    releases?.length
  "
  class="dvq-row dvq-filter-chips">
  <dcc-chip
    *ngFor="let company of companies"
    icon="company"
    [item]="company"
    [value]="company.name"
    (delete)="removeEntity($event)"></dcc-chip>

  <dcc-chip
    *ngFor="let group of groups"
    icon="group"
    [item]="group"
    [value]="group.name"
    (delete)="removeEntity($event)"></dcc-chip>

  <dcc-chip
    *ngFor="let device of devices"
    icon="device"
    [item]="device"
    [value]="device.name"
    (delete)="removeEntity($event)"></dcc-chip>

  <dcc-chip
    *ngFor="let module of selectedModules"
    icon="module"
    [item]="module"
    [selectableItems]="statusOptions"
    value="{{ module.name }} ({{ module.version }})"
    (delete)="removeModule($event)"
    (selectionChanged)="onSelectionChanged($event, module)"></dcc-chip>

  <dcc-chip
    *ngFor="let cohort of cohorts"
    icon="cohort"
    [item]="cohort"
    [value]="cohort.name"
    (delete)="removeCohort($event)"></dcc-chip>

  <dcc-chip
    *ngFor="let release of releases"
    icon="release"
    [item]="release"
    [value]="release.name"
    (delete)="removeRelease($event)"></dcc-chip>
</div>
